var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11885_17156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81055 15.5352C5.67599 15.5722 5.5315 15.5733 5.36621 15.5312L5.36621 15.5303C5.04931 15.4472 4.83257 15.2484 4.75781 15.0166L4.75781 15.0156C4.68705 14.7969 4.74948 14.5406 4.95703 14.3311C5.0864 14.2002 5.22752 14.0775 5.38086 13.9414L5.38184 13.9404L6.7334 12.7256C7.97558 11.6086 9.21874 10.4909 10.4629 9.375L10.4629 9.37402L10.7188 9.14258L10.874 9.00293L10.7188 8.86426L10.46 8.63379C9.45505 7.73507 8.45219 6.83533 7.44922 5.93555L5.0127 3.75293C4.90395 3.65415 4.7141 3.47598 4.69043 3.22559L4.69043 3.11328C4.70705 2.95456 4.76391 2.82751 4.85352 2.72754C4.9443 2.62638 5.07823 2.54309 5.2627 2.4873L5.26367 2.48633C5.37235 2.45292 5.47602 2.43752 5.57617 2.4375C5.79709 2.4375 6.00471 2.51866 6.18067 2.67383L7.69824 4.03809L7.99902 4.31055L8 4.31055C8.07358 4.38897 8.13931 4.45123 8.18164 4.49023L8.18359 4.49219L10.6191 6.67383C11.4839 7.45204 12.3513 8.2286 13.2197 9.00488L12.0557 10.0527L12.0498 10.0469L11.9248 10.1602L6.2334 15.2852C6.08544 15.4187 5.94665 15.4977 5.81055 15.5352Z",
    fill: "#0050AB",
    stroke: "white",
    strokeWidth: 0.375
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11885_17156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.be5b0b31ba96ed13a481808603396eaa.svg";
export { ForwardRef as ReactComponent };